"use client"

import { useState } from "react"

import { postResendEmailVerification } from "@/client-api/profile/email"
import { Button } from "@/components/ui/button"
import { useToast } from "@/components/ui/use-toast"

import { verificationBannerTexts as t } from "./localization/texts"

type VerificationBannerEmailButtonProps = {
  className: string
}

export function VerificationBannerEmailButton({
  className
}: VerificationBannerEmailButtonProps) {
  const { toast } = useToast()
  const [isSending, setIsSending] = useState(false)

  async function handleVerifyEmail() {
    if (isSending) return

    setIsSending(true)
    const result = await postResendEmailVerification()
    setIsSending(false)

    if (!result.ok && result.reason === "rate_limited") {
      toast({
        title: t.email.limitTitle,
        description: t.email.limitDescription,
        variant: "destructive"
      })
      return
    }

    if (!result.ok) {
      toast({
        title: t.email.errorTitle,
        description: t.email.errorDescription,
        variant: "destructive"
      })
      return
    }

    toast({
      title: t.email.sentTitle,
      description: t.email.sentDescription
    })
  }

  return (
    <Button
      type="button"
      variant="hand"
      className={className}
      disabled={isSending}
      onClick={handleVerifyEmail}
    >
      {t.email.button}
    </Button>
  )
}
